import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Phone, Mail, Shield, KeyRound } from "lucide-react";
import client, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { SectionTitle, Card, Pill, Loading } from "../components/common";

export default function AccountPage() {
  const { user, refresh } = useAuth();
  const [pw, setPw] = useState({ old_password: "", new_password: "" });
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" />;

  const change = async () => {
    try { await client.post("/auth/change-password", pw); setPw({ old_password: "", new_password: "" }); toast.success("Password updated"); refresh(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div className="max-w-2xl mx-auto" data-testid="account-page">
      <SectionTitle kicker="Fan account">My account</SectionTitle>
      <Card className="p-6 space-y-4">
        <Row icon={Shield} label="Username" value={user.username} />
        <Row icon={Mail} label="Email" value={user.email || "hidden"} />
        <Row icon={Phone} label="Phone" value={user.phone || "hidden"} extra={<Pill tone="green">2FA on</Pill>} />
        <Row icon={KeyRound} label="Role" value={user.role} />
        {user.fantasy_team_name && <Row icon={Shield} label="Fantasy team" value={user.fantasy_team_name} />}
      </Card>
      <Card className="p-6 mt-4">
        <h3 className="font-head font-bold text-green mb-3">Change password</h3>
        <input type="password" placeholder="Current password" className="w-full border border-pslborder rounded-sm p-3 text-sm mb-2 focus:outline-none focus:border-gold" value={pw.old_password} onChange={(e) => setPw({ ...pw, old_password: e.target.value })} data-testid="acct-oldpw" />
        <input type="password" placeholder="New password" className="w-full border border-pslborder rounded-sm p-3 text-sm mb-3 focus:outline-none focus:border-gold" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} data-testid="acct-newpw" />
        <button onClick={change} className="px-5 py-2.5 bg-green text-cream font-bold rounded-sm hover:bg-ink transition-colors" data-testid="acct-change-pw">Update password</button>
      </Card>
      <p className="text-xs text-ink/40 mt-3">Your email and phone are private. Only Super Admins can view fan PII — never media, sales, staffers or clubs.</p>
    </div>
  );
}

function Row({ icon: Icon, label, value, extra }) {
  return (
    <div className="flex items-center gap-3 border-b border-pslborder pb-3 last:border-0 last:pb-0">
      <Icon size={18} className="text-gold" />
      <span className="text-xs uppercase tracking-wider text-ink/50 w-28">{label}</span>
      <span className="font-semibold flex-1">{value}</span>
      {extra}
    </div>
  );
}
